import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import PhotoMixin from '@/helpers/vue_mixins/v2/PhotoMixin';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
let RadioCardItem = class RadioCardItem extends Mixins(PhotoMixin, OrangeThemeMixin, ViewportSizeMixin, AppDetailsMixin) {
    get maskedNumber() {
        if (this.mobileNumber) {
            const number = this.mobileNumber;
            const maskedSection = '*'.repeat(6);
            const lastFour = number.slice(0, number.length - 6);
            return lastFour + maskedSection;
        }
        if (this.bankAccountNumber) {
            return this.maskExceptLastFour(this.bankAccountNumber);
        }
        if (this.cardNumber) {
            return this.maskExceptLastFour(this.cardNumber);
        }
        return '';
    }
    maskExceptLastFour(number) {
        const maskedSection = '*'.repeat(number.length - 4);
        const lastFour = number.slice(-4);
        return maskedSection + lastFour;
    }
};
__decorate([
    Prop({ type: String, default: null })
], RadioCardItem.prototype, "paymentMethod", void 0);
__decorate([
    Prop({ type: String, default: null })
], RadioCardItem.prototype, "customerName", void 0);
__decorate([
    Prop({ type: String, required: true })
], RadioCardItem.prototype, "uuid", void 0);
__decorate([
    Prop({ type: String, required: false })
], RadioCardItem.prototype, "mobileNumber", void 0);
__decorate([
    Prop({ type: String, required: false })
], RadioCardItem.prototype, "bankAccountNumber", void 0);
__decorate([
    Prop({ type: String, required: false })
], RadioCardItem.prototype, "cardNumber", void 0);
__decorate([
    Prop({ type: Boolean })
], RadioCardItem.prototype, "activated", void 0);
__decorate([
    Prop({ type: Boolean })
], RadioCardItem.prototype, "editable", void 0);
RadioCardItem = __decorate([
    Component
], RadioCardItem);
export default RadioCardItem;
